import { useContext } from "react";
import { useRecoilValue } from "recoil";
import { env } from "../../env/env";
import { DesignProduct } from "../../util/Products";
import { memberState } from "../../state/atoms";
import { isProSubscription } from "../../service/BillingService";
import { AppContext } from "../../AppContext";
import { synchronousRequest } from "../../util/utils";
import { isTestEnv } from "../../util/constants";

export interface DesignProductCardProps {
  product: DesignProduct;
}

export default function DesignProductCard({ product }: DesignProductCardProps) {
  const member = useRecoilValue(memberState);
  const { location: activeLocation } = useContext(AppContext);

  const canManageBrand =
    member.owner || member.role === "Admin" || (member as any).manageBrand;

  if (product.key === "brand-management" && !canManageBrand) {
    return null;
  }

  function onProductClick() {
    if (product.key === "display-app") {
      window.location.href = `${env.dashboardPath}/dsa/manage`;
      return;
    }
    if (product.key === "brand-management") {
      window.location.href = `${env.dashboardPath}/account/brand-management`;
      return;
    }
    if (product.key === "online-menu") {
      setTimeout(() => {
        const resp = synchronousRequest(`/app/online/location/stats/${activeLocation.internalId!}?oo=true`);
        let location: any | null = null;
        if (resp) {
          try {
            location = JSON.parse(JSON.parse(resp).data).location;
          } catch (e) {
            console.error(e);
          }
        }

        if (location?.inUse) {
          return;
        } else {
          const base = isTestEnv ? 'https://test.mhmfun.com' : 'https://ohbz.com';
          const tkn = window.localStorage.getItem("tkn");
          window.open(`${base}${env.ooContextPath}?businessId=${activeLocation.internalId}&tkn=${tkn}`, '_blank');
        }
      }, 200);
      return;
    }
    if (product.premium && !isProSubscription(member)) {
      window.location.href = env.dashboardPath + "/account/plan";
    } else {
      const templateId = product.key === "menu-letter" ? env.samplePrintMenuTemplateId
        : product.key === "digital-menu-board" ? env.sampleDigitalMenuTemplateId
        : null;
      if (templateId) {
        window.location.href = env.timberContextPath + "/design?parentId=" + templateId + "&fromSample=true";
      } else {
        window.location.href = env.timberContextPath + "/design?size=" + product.key;
      }
    }
  }

  if (product.icon) {
    return (
      <li>
        <div onClick={() => onProductClick()} className="pro-dashboard-pill">
          <img
            src={product.icon}
            alt={product.name}
            className={`pro-dashboard-pill-icon pro-dashboard-pill-icon-${product.key}`}
          />
          <p className="pro-dashboard-pill-label">{product.name}</p>
        </div>
      </li>
    );
  }

  return (
    <li className={product.premium && !isProSubscription(member) ? 'gray-out' : ''}>
      <span onClick={() => onProductClick()} className={isProSubscription(member) ? 'pro-dashboard-item' : ''}>
        <h6>{product.name}</h6>
        <img
          loading="lazy"
          src={product.img}
          alt={product.name}
        />
      </span>
      {product.premium && !isProSubscription(member) &&
      <img className="pro-star" src="https://timber.mhmcdn.com/site/marketing/icons/ProPricingStar.svg" alt="pro star"/>}
    </li>
  );
}
